import { DownloadsActivator } from "Feature/Downloads/DownloadsActivator";
import "./MapOptionsElement.less";
import { OptionsStore } from "./OptionsStore";

export class MapOptionsElement extends HTMLElement {
    static tag = "map-options";
    
    connectedCallback() { 
        this.innerHTML = this.view(OptionsStore.instance.showRoutes);
        this.addEventListener("click", this.clickHandler);
    }

    disconnectedCallback() { 
        this.removeEventListener("click", this.clickHandler);
    }

    private clickHandler = (e: MouseEvent) => { 
        const button = e.target as HTMLButtonElement;

        if (button.id === "downloads") { 
            DownloadsActivator.show();
            return;
        }

        button.toggleAttribute("down");
        OptionsStore.instance.showRoutes = button.hasAttribute("down");
    }

     private view = (value: boolean) => `
        <button id="history" ${value ? "down" : ""}>Vis historik</button>
        <button id="downloads">Download App</button>
    `;
}

customElements.define(MapOptionsElement.tag, MapOptionsElement);